// @flow

export type CurrencyType = 'AUD' | 'USD' | 'EUR' | 'GBP' | 'ZAR';

export type CurrencySymbol = '$' | '€' | '£' | 'R';

type CurrencyMapType = {
  [CurrencyType]: CurrencySymbol,
};

export const currencyMap: CurrencyMapType = {
  AUD: '$',
  USD: '$',
  EUR: '€',
  GBP: '£',
  ZAR: 'R',
};

export const CURRENCY: { [CurrencyType]: CurrencyType } = {
  AUD: 'AUD',
  EUR: 'EUR',
  GBP: 'GBP',
  USD: 'USD',
  ZAR: 'ZAR',
};

export const CURRENCY_SYMBOLS: { [CurrencyType]: string } = {
  AUD: '$',
  USD: '$',
  EUR: '€',
  GBP: '£',
  ZAR: 'R',
};

export const formatCurrency = (price: number, currency: CurrencyType = 'USD') => {
  const roundedPrice = Math.round(price);
  const localesMap = {
    AUD: 'en-AU',
    EUR: 'en-UK',
    GBP: 'en-GB',
    USD: 'en-US',
    ZAR: 'en-ZA',
  };
  return roundedPrice.toLocaleString(localesMap[currency] || 'en', {
    currency,
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  });
};
